import React, { useContext } from 'react';
import { Button, Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { URLContext } from '../../contexts/URLContext';

const HeaderBar = styled.div`
  padding: 10px;
  width: 100%;
  max-width: 550px;
  background-size: cover;
  position: fixed;
  z-index: 2;
`;

const CustomLink = styled(Link)`
  text-decoration: none;
`;

const InternalHeader = (props) => {
  const {baseURL, globalUserID, globalCampaignID, campaignData} = useContext(URLContext);

  return (
    <HeaderBar style={{ backgroundImage: `url(${baseURL}${campaignData.imgHeaderInterna})` }}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          {globalUserID !== null && (
            <CustomLink to={`/?id=${globalUserID}&campaign=${globalCampaignID}`}>
              <Button style={{minWidth: "unset"}}>
                <ArrowBackIcon className="white--text" />
              </Button>
            </CustomLink>
          )}
        </Grid>
        <Grid item xs={9} align="right">
          <CustomLink to={`/${props.to}`}>
            <Button className="white--text bold-text"
              variant="outlined"
              style={{border: "transparent"}}
            >
              {props.to}
            </Button>
          </CustomLink>
        </Grid>
      </Grid>
    </HeaderBar>
  )
}

export default InternalHeader;